import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, Card, Container, Row, Col, Form } from "react-bootstrap";
import { ResidentsActions, SuperAdminAction } from "../../Actions";
import CustomContentAlert, {
  routing_using_history,
  isEmailValid,
  validation_message,
  regExForPhone,
  email_validation_message,
  validations,
  PasswordValidation,
} from "../helper";
class AddResidents extends Component {
  constructor(props) {
    super(props);
    this.state = {
      suite_id: "",
      parking_spot: "",
      first_name: "",
      last_name: "",
      phone: "",
      email: "",
      do_not_allow_login: false,
      password: "",
      company_id: this.props.company_id,
      isFormValid: false,
      validSuiteId: true,
      validParkingSpot: true,
      validFirstName: true,
      validLastName: true,
      validPhone: true,
      validEmail: true,
      show_alert: false,
      api_success_message: "",
      api_error_message: "",
      show_error: false,
      property_id: "",
      property: this.props.property,
      phoneErrorMessage: "",
      passwordErrorMsg: "",
      passwordValue: true,
      passwordVisible: false,
      country_code: "",
      country_code_list: [
        { text: "+1", value: "+1" },
        { text: "+91", value: "+91" },
        { text: "+44", value: "+44" },
        { text: "+61", value: "+61" },
      ],
      phone_options: [],
    };
  }

  componentDidMount() {
    this.setState(
      {
        property_id: this.props.property_id,
      },
      () => {
        const selectedPropertyName = this.state.property?.property_name;
        const selectedDomainName = this.state.property?.domain;
        this.props.setDomainHeader(selectedPropertyName, selectedDomainName);
      }
    );
  }

  TogglePasswordVisibility = () => {
    this.setState({
      passwordVisible: !this.state.passwordVisible,
    });
  };

  handlePhoneOptions = (index, value, type) => {
    console.log("index, value :::::", index, value, type);
    const { phone_options } = this.state;
    console.log("phone_options:::", phone_options);

    let phone_values;
    let country_code_values;

    if (type === "phone_number_options") {
      phone_values = value.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1");
      phone_options[index].phone = phone_values;
    }
    if (type === "country_code_options") {
      country_code_values = value;
      phone_options[index].country_code = country_code_values;
    }

    this.setState(
      {
        phone_options: [...phone_options],
      },
      async () => {
        this.handlephoneOptionValidation();
      }
    );

    console.log("phone_options::::", phone_options);
  };

  removePhoneOption = (index) => {
    const { phone_options } = this.state;
    console.log("index", index);

    this.setState(
      {
        phone_options: [...phone_options.filter((_x, i) => i !== index)],
      },
      async () => {
        this.handlephoneOptionValidation();
      }
    );
  };

  handleAddPhoneOptions = () => {
    console.log("handleAddPhoneOptions called::---");
    const { phone_options } = this.state;

    this.setState(
      {
        phone_options: [...phone_options, { country_code: "+1", phone: "" }],
      },
      async () => {
        this.handlephoneOptionValidation();
      }
    );
  };

  handlephoneOptionValidation = () => {
    const { email, first_name, last_name, suite_id, phone, password } =
      this.state;

    const isEmailValidate = isEmailValid(email);
    const high_security = this.props.property.high_security;
    let passwordValue = 1;

    let isValidPhone = true;
    if ((phone && phone.length >= 11) || (phone && phone.length < 10)) {
      this.setState({
        phoneErrorMessage: "Please enter valid phone number",
      });
      isValidPhone = false;
    } else {
      this.setState({
        phoneErrorMessage: "",
      });
    }

    if (high_security) {
      const errMsg = PasswordValidation(password);
      this.setState({
        passwordErrorMsg: errMsg,
      });
      if (errMsg) {
        passwordValue = false;
        this.setState({
          passwordErrorMsg: errMsg,
        });
      } else {
        passwordValue = true;
        this.setState({
          passwordErrorMsg: "",
        });
      }
    }
    console.log(
      "this.isMultiplePhoneValid::::onAddd====",
      this.isMultiplePhoneValid()
    );
    this.checkAllValidations(
      isEmailValidate,
      first_name,
      last_name,
      suite_id,
      phone.length,
      isValidPhone,
      passwordValue
    );
  };

  isMultiplePhoneValid = () => {
    const { phone_options } = this.state;

    const validPhone = phone_options.map((options) => {
      if (
        options.phone.trim().length > 10 ||
        options.phone.trim().length < 10 ||
        options.phone.trim().length === 0
      ) {
        return !(
          options.phone.trim().length > 10 ||
          options.phone.trim().length < 10 ||
          options.phone.trim().length === 0
        );
      }
      return true;
    });
    console.log("validPhone:::", validPhone);
    return !validPhone.includes(false);
  };

  handleChange = ({ target }) => {
    const prevstate = this.state.phone;
    this.setState({ [target.name]: target.value }, async () => {
      const { suite_id, phone, email, first_name, last_name, property } =
        this.state;
      const isEmailValidate = isEmailValid(email);
      const high_security = this.props.property.high_security;
      let passwordValue = 1;
      switch (target.name) {
        case "suite_id":
          {
            const SuiteID = validations(
              target.name,
              "suite_id",
              this.state.suite_id
            );
            this.setState({
              suite_id: SuiteID.value,
              validSuiteId: SuiteID.validator,
              email: SuiteID.validator
                ? `${SuiteID.value}@${property?.domain}.com`
                : "",
            });
          }
          break;
        case "first_name":
          {
            const FirstName = validations(
              target.name,
              "first_name",
              this.state.first_name
            );
            this.setState({
              first_name: FirstName.value,
              validFirstName: FirstName.validator,
            });
          }
          break;
        case "last_name":
          {
            const LastName = validations(
              target.name,
              "last_name",
              this.state.last_name
            );
            this.setState({
              last_name: LastName.value,
              validLastName: LastName.validator,
            });
          }
          break;
        case "phone": {
          if (phone.trim().length) {
            if (regExForPhone.test(target.value)) {
              this.setState({ phone: target.value });
            } else {
              this.setState({ phone: prevstate });
            }
          } else {
            const Phone = validations(target.name, "phone", this.state.phone);
            this.setState({
              phone: Phone.value,
              validPhone: Phone.validator,
            });
          }
          break;
        }
        case "password": {
          if (high_security) {
            const errMsg = PasswordValidation(target.value);
            this.setState({
              passwordErrorMsg: errMsg,
            });
            if (errMsg) {
              passwordValue = false;
              this.setState({
                passwordErrorMsg: errMsg,
              });
            } else {
              passwordValue = true;
              this.setState({
                passwordErrorMsg: "",
              });
            }
          }
          break;
        }
        case "country_code": {
          this.setState({
            country_code: target.value.replace(/[a-zA-Z]/, ""),
          });
          break;
        }
        case "email":
          {
            const Email = validations(target.name, "email", this.state.email);
            this.setState({
              email: Email.value,
              validEmail: Email.validator,
            });
          }
          break;
        default:
          <div></div>;
          break;
      }
      this.setState({ wrongEmail: !isEmailValidate }, () => {
        let isValidPhone = true;
        if ((phone && phone.length >= 11) || (phone && phone.length < 10)) {
          this.setState({
            phoneErrorMessage: "Please enter valid phone number",
          });
          isValidPhone = false;
        } else {
          this.setState({
            phoneErrorMessage: "",
          });
        }
        console.log(
          "this.isMultiplePhoneValid::::====",
          this.isMultiplePhoneValid()
        );
        this.checkAllValidations(
          isEmailValidate,
          first_name,
          last_name,
          suite_id,
          this.state.phone.length,
          isValidPhone,
          passwordValue
        );
      });
    });
  };

  handleCheckBox = () => {
    console.log("do_not_allow_login before:::", this.state.do_not_allow_login);

    this.setState({ do_not_allow_login: !this.state.do_not_allow_login });

    console.log("do_not_allow_login after:::", this.state.do_not_allow_login);
  };

  handleSubmit = () => {
    const userInfo = this.props.UserProfileDetails;
    this.setState({ isFormValid: false }, async () => {
      const {
        suite_id,
        parking_spot,
        first_name,
        last_name,
        phone,
        email,
        do_not_allow_login,
        password,
        company_id,
        property_id,
        country_code,
        phone_options,
      } = this.state;

      const obj = {
        ...userInfo,
        suite_id,
        parking_spot,
        first_name,
        last_name,
        phone,
        email,
        do_not_allow_login,
        password,
        level: 3,
        user: email,
        // password: "12341234",
        company_id,
        active: 0,
        permits_allowed: "4",
        user_type: "unit",
        property_id: property_id,
        country_code,
        phone_options,
      };
      console.log("Obj on add::::", obj);
      if (
        suite_id.trim().length &&
        first_name.trim().length &&
        last_name.trim().length &&
        phone.trim().length &&
        email.trim().length
      ) {
        // console.log("prop", PropertyId);
        // this.props.add_resident(PropertyId, obj).then((res) => {
        await this.props.add_resident(obj);
        if (this.props.api_response) {
          this.setState({
            show_alert: true,
            api_success_message: "Unit created successfully",
          });
          setTimeout(() => {
            this.setState({ show_alert: false });
            routing_using_history("/units");
          }, 4000);
        } else {
          this.setState({
            show_error: true,
            api_error_message: this.props.api_error_message,
          });
          setTimeout(() => {
            this.setState({ show_error: false });
          }, 4000);
        }
      }
    });
  };

  checkAllValidations = (
    isEmailValidate,
    first_name,
    last_name,
    suite_id,
    phoneLength,
    isValidPhone,
    passwordValue
  ) => {
    if (
      isEmailValidate &&
      first_name &&
      last_name &&
      suite_id &&
      phoneLength &&
      isValidPhone &&
      passwordValue &&
      this.isMultiplePhoneValid()
    ) {
      this.setState({ isFormValid: true });
    } else {
      this.setState({ isFormValid: false });
    }
  };

  handleBack = () => {
    routing_using_history("/units");
  };

  render() {
    const {
      suite_id,
      parking_spot,
      first_name,
      last_name,
      phone,
      email,
      do_not_allow_login,
      password,
      wrongEmail,
      validSuiteId,
      validParkingSpot,
      validFirstName,
      validLastName,
      validPhone,
      validEmail,
      isFormValid,
      show_alert,
      api_success_message,
      api_error_message,
      show_error,
      passwordErrorMsg,
      passwordVisible,
      country_code,
      country_code_list,
      phone_options,
      phoneErrorMessage,
    } = this.state;
    return (
      <div>
        <Container fluid>
          <Row>
            <Col md="12">
              <Card>
                <Card.Header style={{ backgroundColor: this.props.main_body }}>
                  <Card.Title as="h4">Add New Unit</Card.Title>
                  <p className="card-category">
                    Fill the Form to add new Units
                  </p>
                </Card.Header>
                {show_alert && (
                  <CustomContentAlert
                    delay={4000}
                    message={api_success_message}
                    className="toast-success"
                  />
                )}
                {show_error && (
                  <CustomContentAlert
                    delay={4000}
                    message={api_error_message}
                    className="toast-error"
                  />
                )}
                <Card.Body className="pos-rel-overflow-hide">
                  {/* <h4 className="mt-0 mb-2">User Profile Settings</h4> */}
                  <Row>
                    <Col md="4" className="pr-md-1">
                      <Form.Group>
                        <label>
                          Unit Id
                          <span className="asterisk">*</span>
                        </label>
                        <Form.Control
                          placeholder="2100"
                          type="text"
                          name="suite_id"
                          value={suite_id}
                          onChange={this.handleChange}
                          autoComplete="off"
                          required
                        />
                        {validation_message(suite_id, "unit Id", validSuiteId)}
                      </Form.Group>
                    </Col>
                    <Col md="4">
                      <Form.Group>
                        <label>Notes</label>
                        {/* <span className="asterisk">*</span> */}
                        <Form.Control
                          placeholder="Unit notes"
                          type="text"
                          name="parking_spot"
                          value={parking_spot}
                          onChange={this.handleChange}
                          autoComplete="new-notes"
                          required
                        />
                        {validation_message(
                          parking_spot,
                          "Parking spot",
                          validParkingSpot
                        )}
                      </Form.Group>
                    </Col>
                    <Col md="4">
                      <Form.Group>
                        <label>Password</label>
                        <div className="input-mask-btn">
                          <Form.Control
                            type={passwordVisible ? "text" : "password"}
                            placeholder="Password"
                            name="password"
                            value={password}
                            autoComplete="new-password"
                            onChange={this.handleChange}
                          />
                          <button
                            className="mask-password"
                            type="button"
                            onClick={this.TogglePasswordVisibility}
                          >
                            <i
                              className={`fas ${
                                passwordVisible ? "fa-eye" : "fa-eye-slash"
                              }`}
                            />
                          </button>
                        </div>
                        <div
                          style={{ color: "red", fontSize: 13 }}
                          dangerouslySetInnerHTML={{ __html: passwordErrorMsg }}
                        ></div>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="4" className="pr-md-1">
                      <Form.Group>
                        <label>
                          First Name
                          <span className="asterisk">*</span>
                        </label>
                        <Form.Control
                          placeholder="John"
                          type="text"
                          name="first_name"
                          value={first_name}
                          onChange={this.handleChange}
                          autoComplete="off"
                          required
                        />
                        {validation_message(
                          first_name,
                          "First Name",
                          validFirstName
                        )}
                      </Form.Group>
                    </Col>
                    <Col md="4">
                      <Form.Group>
                        <label>
                          Last Name
                          <span className="asterisk">*</span>
                        </label>
                        <Form.Control
                          placeholder="Smith"
                          type="text"
                          name="last_name"
                          value={last_name}
                          onChange={this.handleChange}
                          autoComplete="off"
                          required
                        />
                        {validation_message(
                          last_name,
                          "Last Name",
                          validLastName
                        )}
                      </Form.Group>
                    </Col>

                    <Col md="4" className="pl-md-1">
                      <Form.Group>
                        <label>
                          Email Address
                          <span className="asterisk">*</span>
                        </label>
                        <Form.Control
                          placeholder="example@gmail.com"
                          type="text"
                          name="email"
                          value={email}
                          onChange={this.handleChange}
                          autoComplete="off"
                          required
                        />
                        {email_validation_message(
                          email,
                          validEmail,
                          wrongEmail
                        )}
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="2" className="">
                      <Form.Group>
                        <label>Country Code</label>
                        <Form.Control
                          as="select"
                          name="country_code"
                          onChange={this.handleChange}
                          value={country_code}
                          required
                        >
                          {country_code_list ? (
                            <>
                              {country_code_list.map((item, index) => (
                                <option key={index} value={item.value}>
                                  {item.text}
                                </option>
                              ))}
                            </>
                          ) : null}
                        </Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md="3">
                      <Form.Group>
                        <label>
                          Phone
                          <span className="asterisk">*</span>
                        </label>
                        <Form.Control
                          placeholder="2145602323"
                          type="text"
                          name="phone"
                          value={phone}
                          onChange={this.handleChange}
                          autoComplete="off"
                          required
                        />
                        {validation_message(phone, "Phone Number", validPhone)}
                        <span className="help-block">
                          {this.state.phoneErrorMessage}
                        </span>
                      </Form.Group>
                    </Col>
                    <Col md="2">
                      <Button
                        size="sm"
                        className="ml-3 mt-4"
                        disabled={
                          phone_options?.length > 9 ||
                          phoneErrorMessage.trim().length !== 0 ||
                          phone.trim().length === 0 ||
                          !this.isMultiplePhoneValid()
                        }
                        onClick={this.handleAddPhoneOptions}
                      >
                        <i className="fas fa-plus-circle"></i>
                      </Button>
                    </Col>
                    <Col md="5"></Col>
                  </Row>
                  {phone_options &&
                    typeof phone_options === "object" &&
                    Array.isArray(phone_options) &&
                    phone_options.map((option, index) => {
                      return (
                        <Row key={index} className="my-0">
                          <Col className="" md="3">
                            <Form.Group>
                              <Form.Control
                                as="select"
                                name="country_code_options"
                                onChange={(e) =>
                                  this.handlePhoneOptions(
                                    index,
                                    e.target.value,
                                    "country_code_options"
                                  )
                                }
                                value={option?.country_code}
                                required
                              >
                                {country_code_list ? (
                                  <>
                                    {country_code_list.map((item, index) => (
                                      <option key={index} value={item.value}>
                                        {item.text}
                                      </option>
                                    ))}
                                  </>
                                ) : null}
                              </Form.Control>
                            </Form.Group>
                          </Col>
                          <Col className="" md="3">
                            <Form.Group className="p-0 m-1">
                              {/* <Form.Label>Option {index + 1}</Form.Label> */}
                              {/* <span className="asterisk">*</span> */}
                              <Form.Control
                                placeholder="Phone Number"
                                type="text"
                                name="phone_number_options"
                                value={option?.phone}
                                // onBlur={(e) => e.target.value.trim() === "" && removeNoteOption(index)}
                                onChange={(e) =>
                                  this.handlePhoneOptions(
                                    index,
                                    e.target.value,
                                    "phone_number_options"
                                  )
                                }
                                maxLength="10"
                                autoComplete="off"
                              />
                            </Form.Group>
                          </Col>
                          <Col md="3" className="mt-2">
                            <Button
                              size="sm"
                              className="ml-2"
                              onClick={() => this.removePhoneOption(index)}
                            >
                              <i className="fas fa-minus"></i>
                            </Button>
                          </Col>
                        </Row>
                      );
                    })}

                  <Row>
                    <Col lg="12">
                      <p className="blue">
                        <span className="font-weight-bold">**Note:</span> The
                        units will receive an email to set their password
                      </p>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6" className="mt-4">
                      <label className="fancy-checkbox">
                        <input
                          type="checkbox"
                          name={"do_not_allow_login"}
                          checked={do_not_allow_login}
                          onChange={this.handleCheckBox}
                          className="custom-control-input"
                          id="do_not_allow_login1"
                        ></input>
                        <span>
                          <i></i>Do not allow login
                        </span>
                      </label>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="12" className="text-right">
                      <Button
                        className="btn-fill"
                        type="button"
                        variant="danger"
                        onClick={this.handleBack}
                      >
                        Back
                      </Button>
                      <Button
                        className="btn-fill ml-2"
                        type="button"
                        variant="info"
                        disabled={!isFormValid}
                        onClick={this.handleSubmit}
                      >
                        Add Units
                      </Button>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = ({
  UserProfileDetails,
  APIResponseDetails,
  Logindetails,
}) => {
  const { company_id, property_id, property } = UserProfileDetails;
  const { backgroundColor } = Logindetails;
  const { MainBackground: main_body } = backgroundColor;
  const { api_response, api_error_message, api_success_message } =
    APIResponseDetails;
  return {
    company_id,
    property_id,
    api_response,
    api_error_message,
    api_success_message,
    property,
    main_body,
  };
};

const mapStateToDispatch = {
  add_resident: ResidentsActions.add_resident,
  setDomainHeader: SuperAdminAction.setDomainHeader,
};

export default connect(mapStateToProps, mapStateToDispatch)(AddResidents);
